(() => {
  if (window.ghWatchAnalytics) return;
  const measurementId = 'G-VDLKN9LW7G';
  const diagnostic = document.currentScript;
  const previewTest = new URLSearchParams(location.search).get('gh_analytics_test') === '1';
  const layer = window.ghWristDataLayer = window.ghWristDataLayer || [];
  const pending = [];
  let initialised = false;
  let privacyLoading = false;
  let attempts = 0;
  let eventCount = 0;
  function state(value) {
    if (diagnostic) diagnostic.dataset.ghAnalyticsState = value;
  }
  function send() { layer.push(arguments); }
  function allowed() {
    const privacy = window.Shopify?.customerPrivacy;
    if (typeof privacy?.analyticsProcessingAllowed !== 'function') return null;
    try { return privacy.analyticsProcessingAllowed() === true; } catch { return null; }
  }
  function eligible() {
    return !window.Shopify?.designMode && (window.Shopify?.theme?.role === 'main' ||
      (previewTest && window.Shopify?.theme?.role === 'unpublished'));
  }
  function start() {
    if (initialised) return;
    initialised = true;
    send('consent', 'default', {
      analytics_storage: 'granted', ad_storage: 'denied',
      ad_user_data: 'denied', ad_personalization: 'denied'
    });
    send('js', new Date());
    send('config', measurementId, {
      send_page_view: false, allow_google_signals: false,
      allow_ad_personalization_signals: false
    });
    if (!document.getElementById('gh-wrist-analytics')) {
      const script = document.createElement('script');
      script.id = 'gh-wrist-analytics';
      script.async = true;
      script.src = 'https://www.googletagmanager.com/gtag/js?id=' + measurementId + '&l=ghWristDataLayer';
      script.onload = () => state('tag_loaded');
      script.onerror = () => state('tag_error');
      state('tag_loading');
      document.head.append(script);
    }
  }
  function flush() {
    const permission = allowed();
    if (permission === null) { loadPrivacy(); return; }
    if (initialised) send('consent', 'update', {analytics_storage: permission ? 'granted' : 'denied'});
    if (!permission) {
      pending.length = 0;
      state('consent_blocked');
      return;
    }
    if (!pending.length) { if (!initialised) state('ready'); return; }
    start();
    while (pending.length) {
      const event = pending.shift();
      // Shopify's publisher handles its own privacy rules. Preview tests only go to GA.
      if (!previewTest) {
        try { window.Shopify?.analytics?.publish?.(event.shopifyName, event.payload)?.catch?.(() => {}); } catch {}
      }
      send('event', event.name, {
        ...event.payload, send_to: measurementId,
        page_location: location.origin + location.pathname, page_title: document.title,
        ...(previewTest ? {debug_mode: true, ar_test: 'theme_preview'} : {})
      });
      eventCount++;
      if (diagnostic) {
        diagnostic.dataset.ghAnalyticsLastEvent = event.name;
        diagnostic.dataset.ghAnalyticsEventCount = String(eventCount);
      }
    }
  }
  function loadPrivacy() {
    if (privacyLoading || attempts >= 5) return;
    state('loading_privacy');
    attempts++;
    if (typeof window.Shopify?.loadFeatures !== 'function') {
      window.setTimeout(flush, 250 * attempts);
      return;
    }
    privacyLoading = true;
    const loaded = error => {
      privacyLoading = false;
      if (error || allowed() === null) {
        state('privacy_unavailable');
        if (attempts < 5) window.setTimeout(flush, 250 * attempts);
        return;
      }
      flush();
    };
    try {
      window.Shopify.loadFeatures([{name: 'consent-tracking-api', version: '0.1'}], loaded);
    } catch (error) { loaded(error); }
  }
  function track(name, data = {}, shopifyName = name) {
    if (!eligible()) { state('preview_disabled'); return; }
    if (!['gh_ar_open', 'gh_ar_camera_start', 'wrist_capture'].includes(name)) return;
    const payload = {
      watch_id: String(data.watch_id || ''),
      watch_name: String(data.watch_name || '').slice(0, 100),
      watch_handle: String(data.watch_handle || '').slice(0, 100)
    };
    if (!payload.watch_id || !payload.watch_handle) return;
    if (pending.length >= 20) pending.shift();
    pending.push({name, payload, shopifyName});
    flush();
  }
  document.addEventListener('visitorConsentCollected', () => { attempts = 0; flush(); });
  window.ghWatchAnalytics = {track};
  state('ready');
  const early = window.ghWatchEventQueue || [];
  window.ghWatchEventQueue = [];
  early.slice(-20).forEach(event => track(...event));
})();
